import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { CartContext } from '../context/CartContext';
import '../styles/Header.css';

const Header = () => {
  const { user, logout } = useContext(AuthContext);
  const { getCartCount } = useContext(CartContext);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    setShowDropdown(false);
    setShowMobileMenu(false);
    navigate('/login');
  };

  const closeMobileMenu = () => {
    setShowMobileMenu(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/" onClick={closeMobileMenu}>
            <h1>OneMart</h1>
          </Link>
        </div>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setShowMobileMenu(!showMobileMenu)}
          aria-label="Toggle menu"
        >
          {showMobileMenu ? '✕' : '☰'}
        </button>
        
        <nav className={`nav-links ${showMobileMenu ? 'active' : ''}`}>
          <Link to="/home" onClick={closeMobileMenu}>Home</Link>
          <Link to="/about" onClick={closeMobileMenu}>About</Link>
          <Link to="/products" onClick={closeMobileMenu}>Products</Link>
          <Link to="/contact" onClick={closeMobileMenu}>Contact</Link>
        </nav>

        <div className="header-right">
          {user ? (
            <div className="user-menu">
              <button 
                className="user-button"
                onClick={() => setShowDropdown(!showDropdown)}
              >
                {user.name || user.email}
              </button>
              {showDropdown && (
                <div className="dropdown">
                  <Link to="/profile" onClick={() => { setShowDropdown(false); closeMobileMenu(); }}>Profile</Link>
                  <button onClick={handleLogout}>Logout</button>
                </div>
              )}
            </div>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="btn-login" onClick={closeMobileMenu}>Login</Link>
              <Link to="/register" className="btn-register" onClick={closeMobileMenu}>Register</Link>
            </div>
          )}
          
          <Link to="/cart" className="cart-icon" onClick={closeMobileMenu}>
            🛒
            {getCartCount() > 0 && (
              <span className="cart-count">{getCartCount()}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
